module.exports = [
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Flag_of_the_Taliban.svg/20px-Flag_of_the_Taliban.svg.png",
        "label": "Afghanistan",
        "value": 93
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Flag_of_South_Africa.svg/20px-Flag_of_South_Africa.svg.png",
        "label": "Afrique du Sud",
        "value": 27
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Flag_of_Albania.svg/20px-Flag_of_Albania.svg.png",
        "label": "Albanie",
        "value": 355
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Flag_of_Algeria.svg/20px-Flag_of_Algeria.svg.png",
        "label": "Algérie",
        "value": 213
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Flag_of_Germany.svg/20px-Flag_of_Germany.svg.png",
        "label": "Allemagne",
        "value": 49
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Flag_of_Andorra.svg/20px-Flag_of_Andorra.svg.png",
        "label": "Andorre",
        "value": 376
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Flag_of_Angola.svg/20px-Flag_of_Angola.svg.png",
        "label": "Angola",
        "value": 244
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Flag_of_Anguilla.svg/20px-Flag_of_Anguilla.svg.png",
        "label": "Anguilla",
        "value": 1264
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Proposed_flag_of_Antarctica_%28Graham_Bartram%29.svg/20px-Proposed_flag_of_Antarctica_%28Graham_Bartram%29.svg.png",
        "label": "Antarctique",
        "value": 672
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/Flag_of_Saudi_Arabia.svg/20px-Flag_of_Saudi_Arabia.svg.png",
        "label": "Arabie saoudite",
        "value": 966
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Flag_of_Argentina.svg/20px-Flag_of_Argentina.svg.png",
        "label": "Argentine",
        "value": 54
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Flag_of_Armenia.svg/20px-Flag_of_Armenia.svg.png",
        "label": "Arménie",
        "value": 374
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Flag_of_Aruba.svg/20px-Flag_of_Aruba.svg.png",
        "label": "Aruba",
        "value": 297
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/6/65/Flag_of_Ascension_Island.svg/20px-Flag_of_Ascension_Island.svg.png",
        "label": "Ascension",
        "value": 247
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Flag_of_Australia.svg/20px-Flag_of_Australia.svg.png",
        "label": "Australie",
        "value": 61
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Flag_of_Austria.svg/20px-Flag_of_Austria.svg.png",
        "label": "Autriche",
        "value": 43
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Flag_of_Azerbaijan.svg/20px-Flag_of_Azerbaijan.svg.png",
        "label": "Azerbaïdjan",
        "value": 994
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Flag_of_the_Bahamas.svg/20px-Flag_of_the_Bahamas.svg.png",
        "label": "Bahamas",
        "value": 1242
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Flag_of_Bahrain.svg/20px-Flag_of_Bahrain.svg.png",
        "label": "Bahreïn",
        "value": 973
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Flag_of_Bangladesh.svg/20px-Flag_of_Bangladesh.svg.png",
        "label": "Bangladesh",
        "value": 880
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Flag_of_Barbados.svg/20px-Flag_of_Barbados.svg.png",
        "label": "Barbade",
        "value": 1246
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Flag_of_Belgium_%28civil%29.svg/20px-Flag_of_Belgium_%28civil%29.svg.png",
        "label": "Belgique",
        "value": 32
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Flag_of_Belize.svg/20px-Flag_of_Belize.svg.png",
        "label": "Belize",
        "value": 501
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Flag_of_Benin.svg/20px-Flag_of_Benin.svg.png",
        "label": "Bénin",
        "value": 229
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/Flag_of_Bermuda.svg/20px-Flag_of_Bermuda.svg.png",
        "label": "Bermudes",
        "value": 1441
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Flag_of_Bhutan.svg/20px-Flag_of_Bhutan.svg.png",
        "label": "Bhoutan",
        "value": 975
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Flag_of_Belarus.svg/20px-Flag_of_Belarus.svg.png",
        "label": "Biélorussie",
        "value": 375
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/Flag_of_Myanmar.svg/20px-Flag_of_Myanmar.svg.png",
        "label": "Birmanie",
        "value": 95
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Bandera_de_Bolivia_%28Estado%29.svg/20px-Bandera_de_Bolivia_%28Estado%29.svg.png",
        "label": "Bolivie",
        "value": 591
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Flag_of_Botswana.svg/20px-Flag_of_Botswana.svg.png",
        "label": "Botswana",
        "value": 267
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Flag_of_Norway.svg/20px-Flag_of_Norway.svg.png",
        "label": "Île Bouvet",
        "value": 47
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Flag_of_Brazil.svg/20px-Flag_of_Brazil.svg.png",
        "label": "Brésil",
        "value": 55
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Flag_of_Brunei.svg/20px-Flag_of_Brunei.svg.png",
        "label": "Brunei",
        "value": 673
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Flag_of_Bulgaria.svg/20px-Flag_of_Bulgaria.svg.png",
        "label": "Bulgarie",
        "value": 359
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Flag_of_Burkina_Faso.svg/20px-Flag_of_Burkina_Faso.svg.png",
        "label": "Burkina Faso",
        "value": 226
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Flag_of_Burundi.svg/20px-Flag_of_Burundi.svg.png",
        "label": "Burundi",
        "value": 257
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Flag_of_Cambodia.svg/20px-Flag_of_Cambodia.svg.png",
        "label": "Cambodge",
        "value": 855
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Flag_of_Cameroon.svg/20px-Flag_of_Cameroon.svg.png",
        "label": "Cameroun",
        "value": 237
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Flag_of_Canada.svg/20px-Flag_of_Canada.svg.png",
        "label": "Canada",
        "value": 1
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Flag_of_Cape_Verde.svg/20px-Flag_of_Cape_Verde.svg.png",
        "label": "Cap-Vert",
        "value": 238
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Flag_of_the_Cayman_Islands.svg/20px-Flag_of_the_Cayman_Islands.svg.png",
        "label": "Îles Caïmans",
        "value": 1345
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Flag_of_the_Central_African_Republic.svg/20px-Flag_of_the_Central_African_Republic.svg.png",
        "label": "République centrafricaine",
        "value": 236
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Flag_of_Chile.svg/20px-Flag_of_Chile.svg.png",
        "label": "Chili",
        "value": 56
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Flag_of_the_People%27s_Republic_of_China.svg/20px-Flag_of_the_People%27s_Republic_of_China.svg.png",
        "label": "Chine",
        "value": 86
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Flag_of_Cyprus.svg/20px-Flag_of_Cyprus.svg.png",
        "label": "Chypre",
        "value": 357
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Flag_of_Colombia.svg/20px-Flag_of_Colombia.svg.png",
        "label": "Colombie",
        "value": 57
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/94/Flag_of_the_Comoros.svg/20px-Flag_of_the_Comoros.svg.png",
        "label": "Comores",
        "value": 269
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Flag_of_the_Democratic_Republic_of_the_Congo.svg/20px-Flag_of_the_Democratic_Republic_of_the_Congo.svg.png",
        "label": "RDC (Congo)",
        "value": 243
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Flag_of_the_Republic_of_the_Congo.svg/20px-Flag_of_the_Republic_of_the_Congo.svg.png",
        "label": "République du Congo",
        "value": 242
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Flag_of_the_Cook_Islands.svg/20px-Flag_of_the_Cook_Islands.svg.png",
        "label": "Îles Cook",
        "value": 682
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Flag_of_North_Korea.svg/20px-Flag_of_North_Korea.svg.png",
        "label": "Corée du Nord",
        "value": 850
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Flag_of_South_Korea.svg/20px-Flag_of_South_Korea.svg.png",
        "label": "Corée du Sud",
        "value": 82
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Flag_of_Costa_Rica.svg/20px-Flag_of_Costa_Rica.svg.png",
        "label": "Costa Rica",
        "value": 506
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Flag_of_C%C3%B4te_d%27Ivoire.svg/20px-Flag_of_C%C3%B4te_d%27Ivoire.svg.png",
        "label": "Côte d'Ivoire",
        "value": 225
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Flag_of_Croatia.svg/20px-Flag_of_Croatia.svg.png",
        "label": "Croatie",
        "value": 385
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Flag_of_Cuba.svg/20px-Flag_of_Cuba.svg.png",
        "label": "Cuba",
        "value": 53
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Flag_of_Cura%C3%A7ao.svg/20px-Flag_of_Cura%C3%A7ao.svg.png",
        "label": "Curaçao",
        "value": 599
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Flag_of_Denmark.svg/20px-Flag_of_Denmark.svg.png",
        "label": "Danemark",
        "value": 45
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Flag_of_Djibouti.svg/20px-Flag_of_Djibouti.svg.png",
        "label": "Djibouti",
        "value": 253
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Flag_of_Dominica.svg/20px-Flag_of_Dominica.svg.png",
        "label": "Dominique",
        "value": 1767
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Flag_of_Egypt.svg/20px-Flag_of_Egypt.svg.png",
        "label": "Égypte",
        "value": 20
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Flag_of_the_United_Arab_Emirates.svg/20px-Flag_of_the_United_Arab_Emirates.svg.png",
        "label": "Émirats arabes unis",
        "value": 971
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Flag_of_Ecuador.svg/20px-Flag_of_Ecuador.svg.png",
        "label": "Équateur",
        "value": 593
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Flag_of_Eritrea.svg/20px-Flag_of_Eritrea.svg.png",
        "label": "Érythrée",
        "value": 291
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Flag_of_Spain.svg/20px-Flag_of_Spain.svg.png",
        "label": "Espagne",
        "value": 34
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Flag_of_Estonia.svg/20px-Flag_of_Estonia.svg.png",
        "label": "Estonie",
        "value": 372
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Flag_of_the_United_States.svg/20px-Flag_of_the_United_States.svg.png",
        "label": "États-Unis",
        "value": 1
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/7/71/Flag_of_Ethiopia.svg/20px-Flag_of_Ethiopia.svg.png",
        "label": "Éthiopie",
        "value": 251
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Flag_of_the_Faroe_Islands.svg/20px-Flag_of_the_Faroe_Islands.svg.png",
        "label": "Îles Féroé",
        "value": 298
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Flag_of_Fiji.svg/20px-Flag_of_Fiji.svg.png",
        "label": "Fidji",
        "value": 679
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Flag_of_Finland.svg/20px-Flag_of_Finland.svg.png",
        "label": "Finlande",
        "value": 358
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Flag_of_France.svg/20px-Flag_of_France.svg.png",
        "label": "France",
        "value": 33
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Flag_of_Gabon.svg/20px-Flag_of_Gabon.svg.png",
        "label": "Gabon",
        "value": 241
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Flag_of_The_Gambia.svg/20px-Flag_of_The_Gambia.svg.png",
        "label": "Gambie",
        "value": 220
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Flag_of_Georgia.svg/20px-Flag_of_Georgia.svg.png",
        "label": "Géorgie",
        "value": 995
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Flag_of_Ghana.svg/20px-Flag_of_Ghana.svg.png",
        "label": "Ghana",
        "value": 233
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Flag_of_Gibraltar.svg/20px-Flag_of_Gibraltar.svg.png",
        "label": "Gibraltar",
        "value": 350
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Flag_of_Greece.svg/20px-Flag_of_Greece.svg.png",
        "label": "Grèce",
        "value": 30
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Flag_of_Grenada.svg/20px-Flag_of_Grenada.svg.png",
        "label": "Grenade",
        "value": 1473
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Flag_of_Greenland.svg/20px-Flag_of_Greenland.svg.png",
        "label": "Groenland",
        "value": 299
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Flag_of_Guam.svg/20px-Flag_of_Guam.svg.png",
        "label": "Guam",
        "value": 1671
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Flag_of_Guatemala.svg/20px-Flag_of_Guatemala.svg.png",
        "label": "Guatemala",
        "value": 502
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/Flag_of_Guinea.svg/20px-Flag_of_Guinea.svg.png",
        "label": "Guinée",
        "value": 224
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Flag_of_Equatorial_Guinea.svg/20px-Flag_of_Equatorial_Guinea.svg.png",
        "label": "Guinée équatoriale",
        "value": 240
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Flag_of_Guinea-Bissau.svg/20px-Flag_of_Guinea-Bissau.svg.png",
        "label": "Guinée-Bissau",
        "value": 245
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Flag_of_Guyana.svg/20px-Flag_of_Guyana.svg.png",
        "label": "Guyana",
        "value": 592
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Flag_of_France_%28lighter_variant%29.svg/20px-Flag_of_France_%28lighter_variant%29.svg.png",
        "label": "Guyane",
        "value": 594
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Flag_of_Haiti.svg/20px-Flag_of_Haiti.svg.png",
        "label": "Haïti",
        "value": 509
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Flag_of_Honduras.svg/20px-Flag_of_Honduras.svg.png",
        "label": "Honduras",
        "value": 504
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/5/5b/Flag_of_Hong_Kong.svg/20px-Flag_of_Hong_Kong.svg.png",
        "label": "Hong Kong",
        "value": 852
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Flag_of_Hungary.svg/20px-Flag_of_Hungary.svg.png",
        "label": "Hongrie",
        "value": 36
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Flag_of_India.svg/20px-Flag_of_India.svg.png",
        "label": "Inde",
        "value": 91
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Flag_of_Indonesia.svg/20px-Flag_of_Indonesia.svg.png",
        "label": "Indonésie",
        "value": 62
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Flag_of_Iraq.svg/20px-Flag_of_Iraq.svg.png",
        "label": "Irak",
        "value": 964
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Flag_of_Iran.svg/20px-Flag_of_Iran.svg.png",
        "label": "Iran",
        "value": 98
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Flag_of_Ireland.svg/20px-Flag_of_Ireland.svg.png",
        "label": "Irlande",
        "value": 353
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Flag_of_Iceland.svg/20px-Flag_of_Iceland.svg.png",
        "label": "Islande",
        "value": 354
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Flag_of_Israel.svg/20px-Flag_of_Israel.svg.png",
        "label": "Israël",
        "value": 972
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Flag_of_Italy.svg/20px-Flag_of_Italy.svg.png",
        "label": "Italie",
        "value": 39
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Flag_of_Jamaica.svg/20px-Flag_of_Jamaica.svg.png",
        "label": "Jamaïque",
        "value": 1876
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Flag_of_Japan.svg/20px-Flag_of_Japan.svg.png",
        "label": "Japon",
        "value": 81
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Flag_of_Jordan.svg/20px-Flag_of_Jordan.svg.png",
        "label": "Jordanie",
        "value": 962
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Flag_of_Kazakhstan.svg/20px-Flag_of_Kazakhstan.svg.png",
        "label": "Kazakhstan",
        "value": 7
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Flag_of_Kenya.svg/20px-Flag_of_Kenya.svg.png",
        "label": "Kenya",
        "value": 254
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Flag_of_Kyrgyzstan.svg/20px-Flag_of_Kyrgyzstan.svg.png",
        "label": "Kirghizistan",
        "value": 996
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Flag_of_Kiribati.svg/20px-Flag_of_Kiribati.svg.png",
        "label": "Kiribati",
        "value": 686
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/1/1f/Flag_of_Kosovo.svg/20px-Flag_of_Kosovo.svg.png",
        "label": "Kosovo",
        "value": 383
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Flag_of_Kuwait.svg/20px-Flag_of_Kuwait.svg.png",
        "label": "Koweït",
        "value": 965
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Flag_of_Laos.svg/20px-Flag_of_Laos.svg.png",
        "label": "Laos",
        "value": 856
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Flag_of_Lesotho.svg/20px-Flag_of_Lesotho.svg.png",
        "label": "Lesotho",
        "value": 266
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Flag_of_Latvia.svg/20px-Flag_of_Latvia.svg.png",
        "label": "Lettonie",
        "value": 371
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Flag_of_Lebanon.svg/20px-Flag_of_Lebanon.svg.png",
        "label": "Liban",
        "value": 961
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Flag_of_Liberia.svg/20px-Flag_of_Liberia.svg.png",
        "label": "Liberia",
        "value": 231
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Flag_of_Libya.svg/20px-Flag_of_Libya.svg.png",
        "label": "Libye",
        "value": 218
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/47/Flag_of_Liechtenstein.svg/20px-Flag_of_Liechtenstein.svg.png",
        "label": "Liechtenstein",
        "value": 423
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/1/11/Flag_of_Lithuania.svg/20px-Flag_of_Lithuania.svg.png",
        "label": "Lituanie",
        "value": 370
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Flag_of_Luxembourg.svg/20px-Flag_of_Luxembourg.svg.png",
        "label": "Luxembourg",
        "value": 352
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Flag_of_Macau.svg/20px-Flag_of_Macau.svg.png",
        "label": "Macao",
        "value": 853
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Flag_of_North_Macedonia.svg/20px-Flag_of_North_Macedonia.svg.png",
        "label": "Macédoine du Nord",
        "value": 389
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Flag_of_Madagascar.svg/20px-Flag_of_Madagascar.svg.png",
        "label": "Madagascar",
        "value": 261
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Flag_of_Malaysia.svg/20px-Flag_of_Malaysia.svg.png",
        "label": "Malaisie",
        "value": 60
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Flag_of_Malawi.svg/20px-Flag_of_Malawi.svg.png",
        "label": "Malawi",
        "value": 265
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Flag_of_Maldives.svg/20px-Flag_of_Maldives.svg.png",
        "label": "Maldives",
        "value": 960
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Flag_of_Mali.svg/20px-Flag_of_Mali.svg.png",
        "label": "Mali",
        "value": 223
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Flag_of_Malta.svg/20px-Flag_of_Malta.svg.png",
        "label": "Malte",
        "value": 356
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Flag_of_the_Northern_Mariana_Islands.svg/20px-Flag_of_the_Northern_Mariana_Islands.svg.png",
        "label": "Îles Mariannes du Nord",
        "value": 1670
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Flag_of_Morocco.svg/20px-Flag_of_Morocco.svg.png",
        "label": "Maroc",
        "value": 212
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/Flag_of_the_Marshall_Islands.svg/20px-Flag_of_the_Marshall_Islands.svg.png",
        "label": "Îles Marshall",
        "value": 692
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Flag_of_France.svg/20px-Flag_of_France.svg.png",
        "label": "Martinique",
        "value": 596
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Flag_of_Mauritius.svg/20px-Flag_of_Mauritius.svg.png",
        "label": "Maurice",
        "value": 230
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/43/Flag_of_Mauritania.svg/20px-Flag_of_Mauritania.svg.png",
        "label": "Mauritanie",
        "value": 222
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Flag_of_France.svg/20px-Flag_of_France.svg.png",
        "label": "Mayotte",
        "value": 262
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Flag_of_Mexico.svg/20px-Flag_of_Mexico.svg.png",
        "label": "Mexique",
        "value": 52
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Flag_of_Moldova.svg/20px-Flag_of_Moldova.svg.png",
        "label": "Moldavie",
        "value": 373
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Flag_of_Monaco.svg/20px-Flag_of_Monaco.svg.png",
        "label": "Monaco",
        "value": 377
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Flag_of_Mongolia.svg/20px-Flag_of_Mongolia.svg.png",
        "label": "Mongolie",
        "value": 976
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Flag_of_Montenegro.svg/20px-Flag_of_Montenegro.svg.png",
        "label": "Monténégro",
        "value": 382
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Flag_of_Mozambique.svg/20px-Flag_of_Mozambique.svg.png",
        "label": "Mozambique",
        "value": 258
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Flag_of_Namibia.svg/20px-Flag_of_Namibia.svg.png",
        "label": "Namibie",
        "value": 264
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/3/30/Flag_of_Nauru.svg/20px-Flag_of_Nauru.svg.png",
        "label": "Nauru",
        "value": 674
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/Flag_of_Nepal.svg/15px-Flag_of_Nepal.svg.png",
        "label": "Népal",
        "value": 977
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Flag_of_Nicaragua.svg/20px-Flag_of_Nicaragua.svg.png",
        "label": "Nicaragua",
        "value": 505
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Flag_of_Niger.svg/20px-Flag_of_Niger.svg.png",
        "label": "Niger",
        "value": 227
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Flag_of_Nigeria.svg/20px-Flag_of_Nigeria.svg.png",
        "label": "Nigeria",
        "value": 234
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Flag_of_Niue.svg/20px-Flag_of_Niue.svg.png",
        "label": "Niue",
        "value": 683
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Flag_of_Norfolk_Island.svg/20px-Flag_of_Norfolk_Island.svg.png",
        "label": "Île Norfolk",
        "value": 6723
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Flag_of_Norway.svg/20px-Flag_of_Norway.svg.png",
        "label": "Norvège",
        "value": 47
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/2/26/Flags_of_New_Caledonia.svg/20px-Flags_of_New_Caledonia.svg.png",
        "label": "Nouvelle-Calédonie",
        "value": 687
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Flag_of_New_Zealand.svg/20px-Flag_of_New_Zealand.svg.png",
        "label": "Nouvelle-Zélande",
        "value": 64
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Flag_of_Oman.svg/20px-Flag_of_Oman.svg.png",
        "label": "Oman",
        "value": 968
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Flag_of_Uganda.svg/20px-Flag_of_Uganda.svg.png",
        "label": "Ouganda",
        "value": 256
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Flag_of_Uzbekistan.svg/20px-Flag_of_Uzbekistan.svg.png",
        "label": "Ouzbékistan",
        "value": 998
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Flag_of_Pakistan.svg/20px-Flag_of_Pakistan.svg.png",
        "label": "Pakistan",
        "value": 92
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Flag_of_Palau.svg/20px-Flag_of_Palau.svg.png",
        "label": "Palaos",
        "value": 680
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Flag_of_Palestine.svg/20px-Flag_of_Palestine.svg.png",
        "label": "Palestine",
        "value": 970
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/Flag_of_Panama.svg/20px-Flag_of_Panama.svg.png",
        "label": "Panama",
        "value": 507
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Flag_of_Papua_New_Guinea.svg/20px-Flag_of_Papua_New_Guinea.svg.png",
        "label": "Papouasie-Nouvelle-Guinée",
        "value": 675
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Flag_of_Paraguay.svg/20px-Flag_of_Paraguay.svg.png",
        "label": "Paraguay",
        "value": 595
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Flag_of_the_Netherlands.svg/20px-Flag_of_the_Netherlands.svg.png",
        "label": "Pays-Bas",
        "value": 31
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Flag_of_Peru.svg/20px-Flag_of_Peru.svg.png",
        "label": "Pérou",
        "value": 51
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Flag_of_the_Philippines.svg/20px-Flag_of_the_Philippines.svg.png",
        "label": "Philippines",
        "value": 63
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Flag_of_the_Pitcairn_Islands.svg/20px-Flag_of_the_Pitcairn_Islands.svg.png",
        "label": "Îles Pitcairn",
        "value": 64
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Flag_of_Poland.svg/20px-Flag_of_Poland.svg.png",
        "label": "Pologne",
        "value": 48
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Flag_of_French_Polynesia.svg/20px-Flag_of_French_Polynesia.svg.png",
        "label": "Polynésie française",
        "value": 689
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Flag_of_Portugal.svg/20px-Flag_of_Portugal.svg.png",
        "label": "Portugal",
        "value": 351
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/6/65/Flag_of_Qatar.svg/20px-Flag_of_Qatar.svg.png",
        "label": "Qatar",
        "value": 974
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Flag_of_France.svg/20px-Flag_of_France.svg.png",
        "label": "La Réunion",
        "value": 262
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Flag_of_Romania.svg/20px-Flag_of_Romania.svg.png",
        "label": "Roumanie",
        "value": 40
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Flag_of_the_United_Kingdom_%283-5%29.svg/20px-Flag_of_the_United_Kingdom_%283-5%29.svg.png",
        "label": "Royaume-Uni",
        "value": 44
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Flag_of_Russia.svg/20px-Flag_of_Russia.svg.png",
        "label": "Russie",
        "value": 7
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Flag_of_Rwanda.svg/20px-Flag_of_Rwanda.svg.png",
        "label": "Rwanda",
        "value": 250
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Flag_of_Saint_Lucia.svg/20px-Flag_of_Saint_Lucia.svg.png",
        "label": "Sainte-Lucie",
        "value": 1758
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Flag_of_San_Marino.svg/20px-Flag_of_San_Marino.svg.png",
        "label": "Saint-Marin",
        "value": 378
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Flag_of_France.svg/20px-Flag_of_France.svg.png",
        "label": "Saint-Pierre-et-Miquelon",
        "value": 508
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Flag_of_the_Solomon_Islands.svg/20px-Flag_of_the_Solomon_Islands.svg.png",
        "label": "Îles Salomon",
        "value": 677
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Flag_of_El_Salvador.svg/20px-Flag_of_El_Salvador.svg.png",
        "label": "Salvador",
        "value": 503
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Flag_of_Samoa.svg/20px-Flag_of_Samoa.svg.png",
        "label": "Samoa",
        "value": 685
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Flag_of_American_Samoa.svg/20px-Flag_of_American_Samoa.svg.png",
        "label": "Samoa américaines",
        "value": 1684
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Flag_of_S%C3%A3o_Tom%C3%A9_and_Pr%C3%ADncipe.svg/20px-Flag_of_S%C3%A3o_Tom%C3%A9_and_Pr%C3%ADncipe.svg.png",
        "label": "Sao Tomé-et-Principe",
        "value": 239
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Flag_of_Senegal.svg/20px-Flag_of_Senegal.svg.png",
        "label": "Sénégal",
        "value": 221
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/ff/Flag_of_Serbia.svg/20px-Flag_of_Serbia.svg.png",
        "label": "Serbie",
        "value": 381
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Flag_of_Seychelles.svg/20px-Flag_of_Seychelles.svg.png",
        "label": "Seychelles",
        "value": 248
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Flag_of_Sierra_Leone.svg/20px-Flag_of_Sierra_Leone.svg.png",
        "label": "Sierra Leone",
        "value": 232
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Flag_of_Singapore.svg/20px-Flag_of_Singapore.svg.png",
        "label": "Singapour",
        "value": 65
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Flag_of_Slovakia.svg/20px-Flag_of_Slovakia.svg.png",
        "label": "Slovaquie",
        "value": 421
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Flag_of_Slovenia.svg/20px-Flag_of_Slovenia.svg.png",
        "label": "Slovénie",
        "value": 386
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Flag_of_Somalia.svg/20px-Flag_of_Somalia.svg.png",
        "label": "Somalie",
        "value": 252
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Flag_of_Sudan.svg/20px-Flag_of_Sudan.svg.png",
        "label": "Soudan",
        "value": 249
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Flag_of_South_Sudan.svg/20px-Flag_of_South_Sudan.svg.png",
        "label": "Soudan du Sud",
        "value": 211
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/1/11/Flag_of_Sri_Lanka.svg/20px-Flag_of_Sri_Lanka.svg.png",
        "label": "Sri Lanka",
        "value": 94
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Flag_of_Sweden.svg/20px-Flag_of_Sweden.svg.png",
        "label": "Suède",
        "value": 46
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Flag_of_Switzerland.svg/15px-Flag_of_Switzerland.svg.png",
        "label": "Suisse",
        "value": 41
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Flag_of_Suriname.svg/20px-Flag_of_Suriname.svg.png",
        "label": "Suriname",
        "value": 597
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Flag_of_Eswatini.svg/20px-Flag_of_Eswatini.svg.png",
        "label": "Eswatini",
        "value": 268
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Flag_of_Syria.svg/20px-Flag_of_Syria.svg.png",
        "label": "Syrie",
        "value": 963
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Flag_of_Tajikistan.svg/20px-Flag_of_Tajikistan.svg.png",
        "label": "Tadjikistan",
        "value": 992
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Flag_of_Tanzania.svg/20px-Flag_of_Tanzania.svg.png",
        "label": "Tanzanie",
        "value": 255
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/7/72/Flag_of_the_Republic_of_China.svg/20px-Flag_of_the_Republic_of_China.svg.png",
        "label": "Taïwan",
        "value": 886
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Flag_of_Chad.svg/20px-Flag_of_Chad.svg.png",
        "label": "Tchad",
        "value": 235
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Flag_of_the_Czech_Republic.svg/20px-Flag_of_the_Czech_Republic.svg.png",
        "label": "République tchèque",
        "value": 420
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Flag_of_Thailand.svg/20px-Flag_of_Thailand.svg.png",
        "label": "Thaïlande",
        "value": 66
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/2/26/Flag_of_East_Timor.svg/20px-Flag_of_East_Timor.svg.png",
        "label": "Timor oriental",
        "value": 670
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/6/68/Flag_of_Togo.svg/20px-Flag_of_Togo.svg.png",
        "label": "Togo",
        "value": 228
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Flag_of_Tokelau.svg/20px-Flag_of_Tokelau.svg.png",
        "label": "Tokelau",
        "value": 690
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Flag_of_Tonga.svg/20px-Flag_of_Tonga.svg.png",
        "label": "Tonga",
        "value": 676
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Flag_of_Trinidad_and_Tobago.svg/20px-Flag_of_Trinidad_and_Tobago.svg.png",
        "label": "Trinité-et-Tobago",
        "value": 1868
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Flag_of_Tunisia.svg/20px-Flag_of_Tunisia.svg.png",
        "label": "Tunisie",
        "value": 216
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Flag_of_Turkmenistan.svg/20px-Flag_of_Turkmenistan.svg.png",
        "label": "Turkménistan",
        "value": 993
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Flag_of_the_Turks_and_Caicos_Islands.svg/20px-Flag_of_the_Turks_and_Caicos_Islands.svg.png",
        "label": "Îles Turques-et-Caïques",
        "value": 1649
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Flag_of_Turkey.svg/20px-Flag_of_Turkey.svg.png",
        "label": "Turquie",
        "value": 90
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Flag_of_Tuvalu.svg/20px-Flag_of_Tuvalu.svg.png",
        "label": "Tuvalu",
        "value": 688
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Flag_of_Ukraine.svg/20px-Flag_of_Ukraine.svg.png",
        "label": "Ukraine",
        "value": 380
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Flag_of_Uruguay.svg/20px-Flag_of_Uruguay.svg.png",
        "label": "Uruguay",
        "value": 598
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Flag_of_Vanuatu.svg/20px-Flag_of_Vanuatu.svg.png",
        "label": "Vanuatu",
        "value": 678
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Flag_of_the_Vatican_City.svg/18px-Flag_of_the_Vatican_City.svg.png",
        "label": "Vatican",
        "value": 379
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Flag_of_Venezuela.svg/20px-Flag_of_Venezuela.svg.png",
        "label": "Venezuela",
        "value": 58
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Flag_of_Vietnam.svg/20px-Flag_of_Vietnam.svg.png",
        "label": "Viêt Nam",
        "value": 84
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Flag_of_Wallis_and_Futuna.svg/20px-Flag_of_Wallis_and_Futuna.svg.png",
        "label": "Wallis-et-Futuna",
        "value": 681
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Flag_of_Yemen.svg/20px-Flag_of_Yemen.svg.png",
        "label": "Yémen",
        "value": 967
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Flag_of_Zambia.svg/20px-Flag_of_Zambia.svg.png",
        "label": "Zambie",
        "value": 260
    },
    {
        "imgSrc": "http://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/Flag_of_Zimbabwe.svg/20px-Flag_of_Zimbabwe.svg.png",
        "label": "Zimbabwe",
        "value": 263
    }
]